import {useTranslation} from "react-i18next";

import {segmentBuildingTypeDescription} from "@reva/shared/segment-description";

import {useNavigateWithQuery} from "../../hooks/navigationHooks";
import {selectSegmentBuildingTypeRentedIndicationPayload} from "../../redux/indicationSelectors";
import {useRevaSelector} from "../../redux/revaHooks";
import {handlePreventDefault} from "../../util/events";
import OrderNumbersElement from "./OrderNumbersElement";
import SnapshotElement from "./SnapshotElement";

interface ObjectElementProps {
    matchPathAddress: boolean;
}

/**
 * Header Element - object information.
 */
export default function ObjectElement({matchPathAddress}: ObjectElementProps) {
    const {t} = useTranslation();
    const navigate = useNavigateWithQuery();
    const payload = useRevaSelector(selectSegmentBuildingTypeRentedIndicationPayload);

    const description = segmentBuildingTypeDescription(payload, t);
    const objectRoute = "/object/overview";

    if (matchPathAddress) {
        return null;
    }

    return (
        <div className="SecondaryHeaderElement HeaderObjectInfo mt-2 mb-1">
            {!!description && (
                <span id="header-object-element">
                    <span className="pi pi-building mr-2"></span>
                    <a href={objectRoute} onClick={handlePreventDefault(() => navigate(objectRoute))}>
                        {description}
                    </a>
                </span>
            )}
            <OrderNumbersElement />
            <SnapshotElement />
        </div>
    );
}
